import { createGraphqlApiHandler } from 'api/apollo-client'
import graphqlApi from 'api/graphql-api'
import projectApis from 'api/project'
import appLoadingFeatureActions from 'feature/app-loading.actions'
import { GetMegaGameContractsQueryVariables } from 'graphql/generated/graphql'
import { createApiHandler } from 'helpers/apiHandler'
import { Redux } from 'types/local'
import { createActionsSet } from 'utils/redux'

const types = {
  GET_PROJECT_DETAIL: createActionsSet.api('project-detail.get-project-detail'),
  GET_PROJECT_MEGA_JACKPOT: createActionsSet.api('project-detail.get-mega-jackpot'),
  GET_PROJECT_PARTICIPANT: createActionsSet.api('project-detail.get-project-participant'),
  GET_PROJECT_STATISTIC: createActionsSet.api('project-detail.get-statistic'),
  RESET_STATE: 'project-detail.reset-state',
}

const getProjectMegaJackpot =
  (variables: GetMegaGameContractsQueryVariables) => async (dispatch: Redux.Dispatch, getState: Redux.GetState) => {
    dispatch({
      type: types.GET_PROJECT_MEGA_JACKPOT.REQUEST,
    })
    dispatch(appLoadingFeatureActions.start())
    try {
      const handleApi = createGraphqlApiHandler(dispatch, getState)
      const response = await handleApi(graphqlApi.getMegaGameContracts(variables))
      dispatch({
        type: types.GET_PROJECT_MEGA_JACKPOT.SUCCESS,
        payload: response,
      })
    } catch (e) {
      dispatch(appLoadingFeatureActions.finish())
      dispatch({ type: types.GET_PROJECT_MEGA_JACKPOT.FAILED, payload: e })
    } finally {
      dispatch(appLoadingFeatureActions.finish())
    }
  }

const getProjectDetail =
  ({ id }: { id: string }) =>
  async (dispatch: Redux.Dispatch, getState: Redux.GetState) => {
    dispatch({
      type: types.GET_PROJECT_DETAIL.REQUEST,
    })
    dispatch(appLoadingFeatureActions.start())
    try {
      const handleApi = createApiHandler(dispatch, getState)
      const response = await handleApi(projectApis.getProjectDetail(id.toString()))
      dispatch({
        type: types.GET_PROJECT_DETAIL.SUCCESS,
        payload: response.data.project,
      })

      Promise.all([
        dispatch(
          getProjectMegaJackpot({
            projectId: id.toString(),
          }),
        ),
        dispatch(getProjectParticipant({ id: id.toString() })),
        dispatch(getProjectStatistic({ id: id.toString() })),
      ])
    } catch (e) {
      dispatch(appLoadingFeatureActions.finish())
      dispatch({ type: types.GET_PROJECT_DETAIL.FAILED, payload: e })
    } finally {
      dispatch(appLoadingFeatureActions.finish())
    }
  }
const getProjectParticipant =
  ({ id }: { id: string }) =>
  async (dispatch: Redux.Dispatch, getState: Redux.GetState) => {
    dispatch({
      type: types.GET_PROJECT_PARTICIPANT.REQUEST,
    })

    dispatch(appLoadingFeatureActions.start())
    try {
      const handleApi = createGraphqlApiHandler(dispatch, getState)
      const response = await handleApi(graphqlApi.getProjectParticipant({ projectId: id.toString() }))
      dispatch({
        type: types.GET_PROJECT_PARTICIPANT.SUCCESS,
        payload: response,
      })
    } catch (e) {
      dispatch({ type: types.GET_PROJECT_PARTICIPANT.FAILED, payload: e })
    } finally {
      dispatch(appLoadingFeatureActions.finish())
    }
  }
const getProjectStatistic =
  ({ id }: { id: string }) =>
  async (dispatch: Redux.Dispatch, getState: Redux.GetState) => {
    dispatch({
      type: types.GET_PROJECT_STATISTIC.REQUEST,
    })
    dispatch(appLoadingFeatureActions.start())
    try {
      const handleApi = createGraphqlApiHandler(dispatch, getState)
      const response = await handleApi(graphqlApi.getProjectStatistic({ projectId: id.toString() }))
      dispatch({
        type: types.GET_PROJECT_STATISTIC.SUCCESS,
        payload: response,
      })
    } catch (e) {
      dispatch(appLoadingFeatureActions.finish())
      dispatch({ type: types.GET_PROJECT_STATISTIC.FAILED, payload: e })
    } finally {
      dispatch(appLoadingFeatureActions.finish())
    }
  }

export const projectDetailActions = {
  types,
  getProjectDetail,
  getProjectMegaJackpot,
}
